<!-- 工艺边框 -->
<template>
  <BaseFormItem2
    class="sidewidth"
    :unit="fields.unit"
    :label="fields.label"
    :labelTips="labelTips"
    :isError="isError"
    :isErrorBlink="isErrorBlink"
    :isShake="isShake"
  >
    <BaseInput2
      v-model="val.sidewidth" 
      width="152px" 
      class="sidewidth__input"
      :disabled="disabledInput || disabled"
      @change="handleSidewidthChange"
    >
      <BaseSelect2 
        slot="prepend"
        v-model="val.sidedirection" 
        width="90px"
        placeholder="请选择"
        :disabled="disabled"
        @change="handleSidedirectionChange"
      >
        <el-option
          v-for="item in fields.options"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </BaseSelect2>
    </BaseInput2>
    <span slot="other" class="sidewidth__tips">
      <i class="el-icon-warning-outline"></i>
      如需在华秋贴片，建议设置不小于5mm的工艺边框; 
      <BaseTipPopover placement="top" content="无工艺边可能会增加额外的治具费用">
        <span slot="reference">为什么？</span>
      </BaseTipPopover>
    </span>
  </BaseFormItem2>
</template>

<script>
import { getFR4Fields } from '@@/utils/getFields'

export default {
  props: {
    sidedirection: {
      type: String,
      default: ''
    },
    sidewidth: {
      type: [Number, String],
      default: 0
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      val: {
        sidedirection: this.sidedirection,
        sidewidth: this.sidewidth
      },
      isError: false, // 是否显示错误提示样式
      isErrorBlink: false, // 是否显示错误提示样式且闪两下
      isShake: false, // 是否抖动两下
    }
  },
  computed: {
    fields() {
      return getFR4Fields('sidewidth')
    },
    labelTips() {
      return this.fields.labelTips
    },
    disabledInput() {
      return this.val.sidedirection === '无'
    },
    // 最小限制
    minLimit() {
      return 3
    }
  },
  watch: {
    sidedirection(sidedirection) {
      this.val.sidedirection = sidedirection
    },
    sidewidth(sidewidth) {
      this.val.sidewidth = sidewidth
    }
  },
  methods: {
    handleEmit(key) {
      this.$emit(`update:${key}`, this.val[key])
      this.isShowError(false)
    },
    handleEmitChange() {
      this.$emit('change', { ...this.val })
    },
    handleSidedirectionChange(val) {
      if (val == '无') {
        this.val.sidewidth = 0
        this.handleEmit('sidewidth')
      } else {
        // 首次选工艺边方向后，工艺边框初始值改为 5
        if (this.val.sidewidth == 0) {
          this.val.sidewidth = 5
          this.handleEmit('sidewidth')
        }
      }
      this.handleEmit('sidedirection')
    },
    handleSidewidthChange(val) {
      const minLimit = this.minLimit
      val = Number(val)
      if (this.val.sidedirection != '无') {
        if (val < minLimit) {
          this.$message.warning(`工艺边最少${minLimit}mm`)
          val = minLimit
        }
        if (val > 999) {
          this.$message.warning('工艺边最宽999mm')
          val = 5
        }
        if (val * 10 % 5 != 0) {
          this.$message.warning('工艺边框仅支持0.5的倍数，比如3.5, 4 , 4.5')
          val = Math.round(val * 2) / 2
        }
        this.val.sidewidth = val
      }
      this.handleEmit('sidewidth')
    },
    // 是否显示错误提示样式
    isShowError(isError) {
      this.isError = isError
    },
    // 是否抖动两下
    isShowShake(isShake) {
      this.isShake = isShake
      const timer = setTimeout(() => {
        this.isShake = false
        clearTimeout(timer)
      }, 300)
    },
  }
}
</script>

<style lang="scss" scoped>
$borderColor: #E1E1E1;
.sidewidth ::v-deep {
  .sidewidth__input {
    .el-input-group__prepend {
      border-top-left-radius: $--border-radius-base2;
      border-bottom-left-radius: $--border-radius-base2;
      border-color: $borderColor;
      background-color: #fff;
      cursor: pointer;
    }
    .el-input__inner {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
  } 
  .el-input.is-disabled {
    .el-input__inner,
    .el-input__icon {
      cursor: pointer;
    }
    .el-input__inner[disabled] {
      cursor: not-allowed;
    }
  }
  .sidewidth__tips {
    font-size: 12px;
    color: $--color-warning;
    >span {
      color: $--color-text-placeholder;
    }
  }
}
</style>